export function Checkbox( props ) {
	return (
		<span className="employee-comms-checkbox--wrapper">
			<input
				type="checkbox"
				className="employee-comms-checkbox"
				{...props}
			/>
			<label htmlFor={props.id}>{props.label}</label>
		</span>
	);
}
export default Checkbox;
